import React from 'react';
import Loader from 'react-loader-spinner'
import './Loading.scss';

function Loading (){
	return (
		<div id="loading">
            <div className="spinner">
			<Loader 
				type="ThreeDots"
				color="#6CBBA8"
				height="100"
				width="100"
			/>
            </div>
		</div>
    );
}

export default Loading;
